
import { NavLink } from "react-router-dom"
import { route, publicUrlFor } from "../../../../globals/constants"
import FastImage from "../../../../globals/elements/fastimg"
import CountUp from "react-countup";

export default function Video1({options, data}) {

    const desc_list = options?.desc_list?.split('#');
 
    return (
        <div className="section-full p-t80 p-b50 bg-no-repeat bg-center bg-white" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg-map.png")})` }}>
        
            <div className="container">
                <div className="row">
                    <div className="col-lg-5 col-md-12">
                        <div className="mt-box m-b30">
                            <div className="mt-thum-bx mt-img-effect  mt-img-overlay2">
                                <FastImage src={options?.image} alt="" />
                                <a href={options?.video} className="mfp-video play-now">
                                    <i className="icon fa fa-play" />
                                    <span className="ripple" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12">
                        <div className="sx-shipment-wrap">
                            <div className="mt-box m-b25">
                                <h2 className="display-block m-b15 m-t0">{options?.title}</h2>
                                <p className="m-b15">{options.description}.</p>
                                <ul className="list-check-circle primary m-b20">
                                    {
                                        desc_list && desc_list?.length > 0 && desc_list?.map((desc,index) => {
                                            return (
                                                <li key={`desc-${index}`}>
                                                    {desc}
                                                </li>
                                            )
                                        })
                                    }
                                   
                                </ul>
                                <NavLink to={route.services.SERVICES} className="site-button">Read More</NavLink>
                            </div>
                            <div className="row">
                                {
                                    data && data.length > 0 && data.map((item,index) => {
                                        return (
                                            <div className="col-md-6 col-sm-6" key={`item-${index}`}>
                                                <div className="m-b30 text-black mt-icon-box-wraper center bdr-1 bdr-solid bdr-gray-light  bg-white p-a20">
                                                    <div className="counter font-42 font-weight-800 m-b15 site-text-primary">
                                                        <CountUp end={item.title} duration={10} />
                                                    </div>
                                                    <h4 className="m-tb0">{item.description}</h4>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}